// extracted by mini-css-extract-plugin
export default {"blockImage":"G5AHGnqxS20ShRWJBtHB","fullWidth":"cXCrvWiLk8buQbfNxvkZ","image":"lQVrP4G_wYeKhlGRdiEm"};